<template>
  <RegisterForm />
</template>
<script>
import RegisterForm from '../components/Auth/Register'
export default {
  name: 'Register',
  components: {
    RegisterForm
  }
}
</script>
